exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ .grid-sup .ag-menu {\n  position: fixed !important;\n  top: 9em !important; }\n\n.btn-batch-credit-trash {\n  right: 10px;\n  position: absolute; }\n\n.item-data-picker {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: stretch;\n      align-items: stretch; }\n  .item-data-picker .row-flex-1 {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n  .item-data-picker .row-flex-2 {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-preferred-size: 130px;\n        flex-basis: 130px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/posting/posting.component.scss
// module id = 1980
// module chunks = 66